import React from "react";
import { Link } from "react-router-dom";
import BankingIcon from "../SvgComponents/BankingIcon";
import FinancialIcon from "../SvgComponents/FinancialIcon";
import InnovationIcon from "../SvgComponents/InnovationIcon";
import Mission from "../SvgComponents/Mission";
import Brain from "../SvgComponents/Brain";
import Cloud from "../SvgComponents/Cloud";
import Modernization from "../SvgComponents/Modernization";
import Workflow from "../SvgComponents/Workflow";

export default function CardFeatures({
  sectionId = "solutions",
  sectionClass = "pt-16 md:pb-[153px]",
  backgroundImages = {
    mobile: "/assets/images/home-nine/features-card-bg-black.png",
    desktop: "/assets/images/home-nine/features-card-bg.svg"
  },
  headerContent = {
    title: "How your company fits in",
    description: "Impera enables banks and fintechs to enter the crypto space with confidence through integrated banking cores, exchanges, and digital asset solutions. Our technology helps institutions launch secure, compliant, and scalable financial innovations."
  },
  cards = [
    {
      id: 1,
      icon: "BankingIcon",
      title: "Bridging Traditional Banking and Crypto",
      description: "Impera integrates banking cores with crypto services to enable seamless financial innovation.",
      link: "/services",
      aosDelay: 0
    },
    {
      id: 2,
      icon: "FinancialIcon", 
      title: "Empowering Financial Institutions",
      description: "Helps banks and fintechs launch digital products like USD accounts that function as crypto wallets.",
      link: "/services",
      aosDelay: 200
    },
    {
      id: 3,
      icon: "InnovationIcon",
      title: "Driving Next-Gen Financial Solutions", 
      description: "Enables secure, compliant, and scalable infrastructure for the evolving digital asset ecosystem.",
      link: "/services",
      aosDelay: 400
    }
  ]
}) {
  // Helper function to render the correct icon component
  const renderIcon = (iconName, className) => {
    switch (iconName) {
      case "BankingIcon":
        return <BankingIcon className={className} />;
      case "FinancialIcon":
        return <FinancialIcon className={className} />;
      case "InnovationIcon":
        return <InnovationIcon className={className} />;
      case "Mission":
        return <Mission className={className} />;
      case "Brain":
        return <Brain className={className} />;
      case "Cloud":
        return <Cloud className={className} />;
      case "Modernization":
        return <Modernization className={className} />;
      case "Workflow":
        return <Workflow className={className} />;
      default:
        return <BankingIcon className={className} />;
    }
  };

  return (
    <section
      id={sectionId}
      className={sectionClass}
    >
      <div className="max-w-[1860px] w-full mx-auto relative bg-main-black sm:bg-transparent pb-6 sm:pb-0">
        <div className="rounded-[20px] overflow-hidden">
          <img
            src={backgroundImages.mobile}
            alt=""
            className="absolute z-0 hidden w-full h-full sm:w-auto sm:h-auto sm:block"
          />
          <img
            src={backgroundImages.desktop}
            alt=""
            className="absolute z-0 hidden  sm:block"
          />
        </div>
        <div className="relative z-10 w-full mx-auto theme-container px-4">
          <div className="w-full flex flex-col sm:flex-row justify-between flex-wrap pt-16 sm:pt-[120px] pb-8 sm:pb-[60px] gap-6 sm:gap-0">
          <h2 className="text-34 sm:text-34 md:text-48 font-semibold text-white mb-8 sm:mb-[50px]  w-full xl:w-full">
              {headerContent.title}
                </h2>
          <p className="max-w-[508px] text-paragraph text-sm sm:text-base leading-relaxed">
            {headerContent.description}
            </p>
          </div>
          {/* <!-- cards  --> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {cards.map((card) => (
              <div
                key={card.id}
                data-aos="fade-up"
                data-aos-delay={card.aosDelay}
                className="price_card_bg_solid px-6 py-8 sm:px-8 sm:py-10 bg-[#160e24] border border-purple/30 rounded-[20px] group transition-all duration-300 hover:border-purple/20 hover:shadow-lg hover:shadow-purple/10"
              >
                <div className="p-4 text-white transition-all duration-300 ease-out rounded-full bg-[#4A7DFF] group-hover:bg-[#0a0118] w-fit">
                  {renderIcon(card.icon, "w-8 h-8 sm:w-10 sm:h-10")}
                </div>
                <Link to={card.link}>
                  <h1 className="pt-6 font-semibold text-18 sm:text-20 md:text-22 text-white line-clamp-2">
                    {card.title}
                  </h1>
                </Link>
                <p className="text-paragraph pt-3.5 line-clamp-3 text-sm sm:text-base leading-relaxed">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
